import { render, staticRenderFns } from "./ItemDescription.vue?vue&type=template&id=39d6433e&scoped=true&"
import script from "./ItemDescription.vue?vue&type=script&lang=js&"
export * from "./ItemDescription.vue?vue&type=script&lang=js&"
import style0 from "./ItemDescription.vue?vue&type=style&index=0&id=39d6433e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d6433e",
  null
  
)

export default component.exports